import React from "react";
import { Formik, Form, Field } from "formik";
import TextInput from "./TextInput";
import ImagesInput from "./ImagesInput";
import { getBreakpointFromWidth } from "../helpers/index";
import Button from "./CustomButton";
import * as Yup from "yup";
import Icon from "@fortawesome/react-fontawesome";
import _ from "lodash";
import useNextFocus from "./useNextFocus";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  price: Yup.number()
    .min(0, "Cannot be less than zero")
    .required("Required")
    .typeError("Invalid number"),
  images: Yup.array().min(1, "At least one image")
});

const initialValues = variant => {
  const initial = {
    name: "",
    price: "",
    images: []
  };
  return variant ? _.pick(variant, Object.keys(initial)) : initial;
};

const VariantForm = ({ variant, onSubmit }) => {
  const breakpoint = getBreakpointFromWidth(window.innerWidth);
  const isSmallScreen = ["xs", "sm"].includes(breakpoint);
  const { setInputRef, focusInput, blurInput } = useNextFocus();
  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      initialValues={initialValues(variant)}
      render={({ submitForm, errors, touched }) => {
        const SubmitButton = (
          <div className="row my-2">
            <div className="col">
              <Button onClick={submitForm} type="button" color="primary" fill>
                {`${variant ? "Update" : "Create"} Variant`}{" "}
                <Icon icon="paper-plane" />
              </Button>
            </div>
          </div>
        );
        return (
          <Form>
            <div className="row">
              <div className="col-md-6 col-sm-12 pr-md-1">
                <div className="card">
                  <div className="content">
                    <Field
                      name="name"
                      label="Name"
                      placeholder="Variant Name"
                      innerRef={setInputRef("name")}
                      onKeyPress={focusInput("price")}
                      component={TextInput}
                    />
                    <Field
                      name="price"
                      label="Price"
                      placeholder="Variant Price"
                      innerRef={setInputRef("price")}
                      onKeyPress={blurInput("price")}
                      component={TextInput}
                    />
                  </div>
                </div>
                {!isSmallScreen && SubmitButton}
              </div>
              <div className="col-md-6 col-sm-12 pl-md-1">
                <div className="card">
                  <div className="content">
                    <h4>
                      <b>Images</b>
                    </h4>
                    <Field name="images" component={ImagesInput} />
                    {errors.images && touched.images && (
                      <p className="text-danger">{errors.images}</p>
                    )}
                  </div>
                </div>
                {isSmallScreen && SubmitButton}
              </div>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default VariantForm;
